import React from "react";
import { Modal } from "antd";
import styles from "./styles.scss";

const VerifyModal = props => {
  const { onOk, onCancel, onClose, noRedirect, ...restProps } = props;

  const handleOk = () => {
    if (noRedirect && onClose) {
      onClose();
    } else if (onOk) {
      onOk();
    }
  };

  const handleCancel = (e) => {
    if (noRedirect && onClose) {
      onClose();
    } else if (onCancel) {
      onCancel(e);
    }
  };

  return (
    <Modal {...restProps} onOk={handleOk} onCancel={handleCancel}>
      <div className={styles.title}>
        {props.heading}
      </div>
      <div className={styles.content} style={{ whiteSpace: "pre-line" }}>
        {props.content}
      </div>

    </Modal>
  );
};

export default VerifyModal;



// WEBPACK FOOTER //
// ./src/components/VerifyModal/index.tsx